import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { modifiersToDatesInMonth, isModifiedDate, } from "@clearabee/ui-library-base";
import { Calendar } from "react-native-calendars";
import dayjs from "dayjs";
import { calendarStyles, calendarTheme } from "./InputDate.styles";
import { theme } from "../../../../theme";
import { Icon } from "../../../Icon/Icon";
import { formatDate, generateRange, getDatesInMonth, } from "./helper";
const today = formatDate();
export const InputRangedDate = ({ onChange, initialValue, disabledDays: propDisabledDays, dateFormat, styles: userStyles, todayMarker = false, firstDay, month, }) => {
    const [dates, setDates] = useState(initialValue?.map((value) => typeof value === "string" ? dayjs(value, dateFormat).toDate() : value) ?? []);
    const current = month ?? dates[0] ?? new Date();
    const monthRef = React.useRef(current);
    const [disabledDays, setDisabledDays] = useState(propDisabledDays
        ? modifiersToDatesInMonth(propDisabledDays, dates[0] ?? new Date()).map((date) => formatDate(date))
        : []);
    const handleMonthChange = (date) => {
        monthRef.current = new Date(date.year, date.month - 1, 1);
        if (propDisabledDays)
            setDisabledDays(modifiersToDatesInMonth(propDisabledDays, new Date(date.year, date.month - 1, 1)).map(formatDate));
    };
    const handlePress = (dateData) => {
        const date = dayjs(dateData.dateString).toDate();
        if (isModifiedDate(date, propDisabledDays ?? [])) {
            return;
        }
        const newDates = dates;
        const newDate = formatDate(date);
        if (newDates.length === 2 ||
            (newDates.length === 1 &&
                dayjs(newDate, dateFormat).isBefore(dayjs(newDates[0], dateFormat)))) {
            newDates.splice(0, 2);
        }
        setDates([...newDates, dayjs(newDate).toDate()]);
    };
    useEffect(() => {
        onChange?.(dates.reduce((dates, date, index) => `${dates}${index ? " - " : ""}${dayjs(date).format(dateFormat)}`, ""));
    }, [dates]);
    const disabledMarks = disabledDays.reduce((final, date) => ({ ...final, [date]: { disabled: true } }), {});
    const isTodayDisabled = disabledDays.includes(today);
    const monthDays = getDatesInMonth(monthRef.current).reduce((final, date) => ({
        ...final,
        [date]: {
            customStyles: {
                container: {
                    backgroundColor: theme.colors.brand.lightest,
                    borderRadius: theme.spacing.xsmall2,
                },
                text: {
                    color: theme.colors.dark.base,
                },
            },
        },
    }), {});
    return (React.createElement(View, { style: userStyles },
        React.createElement(Calendar
        // Types are wrong, created issue: https://github.com/wix/react-native-calendars/issues/1662
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        , { 
            // Types are wrong, created issue: https://github.com/wix/react-native-calendars/issues/1662
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onMonthChange: handleMonthChange, current: current, day: dates[0], firstDay: firstDay, onDayPress: handlePress, style: calendarStyles, markingType: "custom", markedDates: {
                ...monthDays,
                ...disabledMarks,
                ...(todayMarker
                    ? {
                        [today]: {
                            customStyles: {
                                container: {
                                    borderWidth: 1,
                                    borderColor: theme.colors.brand.base,
                                    opacity: isTodayDisabled ? 0.5 : 1,
                                    borderRadius: theme.spacing.xsmall2,
                                },
                                text: {
                                    color: "black",
                                    fontWeight: "bold",
                                    opacity: isTodayDisabled ? 0.5 : 1,
                                },
                            },
                            disabled: isTodayDisabled,
                        },
                    }
                    : {}),
                ...generateRange(dates).reduce((dates, date) => ({
                    ...dates,
                    [formatDate(date)]: {
                        startingDay: true,
                        customStyles: {
                            container: {
                                backgroundColor: theme.colors.brand[monthRef.current.getMonth() === date.getMonth()
                                    ? "base"
                                    : "lighter"],
                                borderRadius: theme.spacing.xsmall2,
                            },
                            text: {
                                color: theme.colors.light.base,
                            },
                        },
                    },
                }), {}),
            }, disabledDaysIndexes: [0, 6], disableAllTouchEventsForDisabledDays: true, theme: calendarTheme, renderArrow: (direction) => (React.createElement(View, { style: direction === "left" && { transform: [{ rotate: "180deg" }] } },
                React.createElement(Icon.Chevron, { color: "brand", size: "small" }))) })));
};
//# sourceMappingURL=InputRangedDate.js.map